<template>
<div style="height:100%">
  <div id="csContainer">
    <div class="toolbar" >
<!--    <el-button  size="small" type="primary" @click="addRectangle()" style="padding: 5px">长方体</el-button>-->
      <el-button  size="small" type="primary" @click="addRectangle()"style="padding: 8px; margin: 5px" >长方体</el-button>

      <br />
    <el-button size="small"  type="primary" @click="addCorridor()" style="padding: 8px; margin: 5px">走廊</el-button>
      <br />
    <el-button  size="small"  type="primary" @click="addCylinders()" style="padding: 8px; margin: 5px">圆锥</el-button>
      <br />
    <el-button  size="small"  type="primary" @click="addSphere()" style="padding: 8px; margin: 5px">球体</el-button>
      <br />
    <el-button  size="small"  type="primary"  plain @click="cancel()" style="padding: 8px; margin: 5px">删除</el-button>
<!--      <el-button class="addRectangle"  size="small" type="primary" @click="addRectangle()" >长方体</el-button>-->
<!--      <el-button class="addCorridor" size="small"  type="primary" @click="addCorridor()" >管道</el-button>-->
<!--      <el-button class="addCylinders" size="small"  type="primary" @click="addCylinders()" >圆柱、圆锥</el-button>-->
<!--      <el-button class="addSphere" size="small"  type="primary" @click="addSphere()" >球、椭球</el-button>-->
<!--      <el-button class="cancel" size="small"  type="info" @click="cancel()" >删除</el-button>-->
    </div>
  </div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'addGeometry',
        data(){
            return{
                viewer: null            }
        },
        mounted(){
           var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
            this.init();
        },
        methods:{
            init(){
                // Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJmZDc4MDllZS01NDZmLTQwNTEtOWYxNy1mZGJhMDVkNjUzOWIiLCJpZCI6MTM0NzksInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1NjMzNTY3MDV9.OGQjCz3Xjb3uNrF89AUmasVwNTFVXFdP6RoqU-q853U';
                Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIzNWZhODgzMC1iNmE5LTQzNWMtOTdiYi00NzAyMzhmZDdmNjgiLCJpZCI6MTg3NTAyLCJpYXQiOjE3MDQyNDkwODl9.81WSf-TbP_6rNXQpVmuQaca_IrKpBje4NKk-BQxt4hg';

                let vm = util.getViewer("csContainer");

                this.viewer = vm;
            },
            addRectangle(){
              let viewer = this.viewer;
              viewer.dataSources.removeAll();
              let czml = [{
                "id" : "document",
                "name" : "box",
                "version" : "1.0"
              }, {
                "id" : "shape1",
                "name" : "Blue box",
                "position" : {
                  "cartographicDegrees" : [-114.0, 40.0, 300000.0]
                },
                "box" : {
                  "dimensions" : {
                    "cartesian": [400000.0, 300000.0, 500000.0]
                  },
                  "material" : {
                    "solidColor" : {
                      "color" : {
                        "rgba" : [0, 0, 255, 255]
                      }
                    }
                  }
                }
              }, {
                "id" : "shape2",
                "name" : "Red box with black outline",
                "position" : {
                  "cartographicDegrees" : [-107.0, 40.0, 300000.0]
                },
                "box" : {
                  "dimensions" : {
                    "cartesian": [400000.0, 300000.0, 500000.0]
                  },
                  "material" : {
                    "solidColor" : {
                      "color" : {
                        "rgba" : [255, 0, 0, 128]
                      }
                    }
                  },
                  "outline" : true,
                  "outlineColor" : {
                    "rgba" : [0, 0, 0, 255]
                  }
                }
              }, {
                "id" : "shape3",
                "name" : "Yellow box outline",
                "position" : {
                  "cartographicDegrees" : [-100.0, 40.0, 300000.0]
                },
                "box" : {
                  "dimensions" : {
                    "cartesian": [400000.0, 300000.0, 500000.0]
                  },
                  "fill" : false,
                  "outline" : true,
                  "outlineColor" : {
                    "rgba" : [255, 255, 0, 255]
                  }
                }
              }];
              let dataSourcePromise = Cesium.CzmlDataSource.load(czml);
              viewer.dataSources.add(dataSourcePromise);
              viewer.zoomTo(dataSourcePromise);
            },
            addCorridor(){
            let viewer = this.viewer;
            viewer.dataSources.removeAll();
            let czml = [{
              "id" : "document",
              "name" : "CZML Geometries: Polyline",
              "version" : "1.0"
            }, {
              "id" : "redCorridor",
              "name" : "Red corridor on surface with rounded corners",
              "corridor" : {
                "positions" : {
                  "cartographicDegrees" : [
                    -100.0, 40.0, 0,
                    -105.0, 40.0, 0,
                    -105.0, 35.0, 0
                  ]
                },
                "width" : 200000.0,
                "material" : {
                  "solidColor" : {
                    "color" : {
                      "rgba" : [255, 0, 0, 127]
                    }
                  }
                }
              }
            }, {
              "id" : "greenCorridor",
              "name" : "Green corridor at height with mitered corners and outline",
              "corridor" : {
                "positions" : {
                  "cartographicDegrees" : [
                    -90.0, 40.0, 0,
                    -95.0, 40.0, 0,
                    -95.0, 35.0, 0
                  ]
                },
                "height" : 100000.0,
                "cornerType" : "MITERED",
                "width" : 200000.0,
                "material" : {
                  "solidColor" : {
                    "color" : {
                      "rgba" : [0, 255, 0, 255]
                    }
                  }
                },
                "outline" : true, // height must be set for outlines to display
                "outlineColor" : {
                  "rgba" : [0, 0, 0, 255]
                }
              }
            }, {
              "id" : "blueCorridor",
              "name" : "Blue extruded corridor with beveled corners and outline",
              "corridor" : {
                "positions" : {
                  "cartographicDegrees" : [
                    -80.0, 40.0, 0,
                    -85.0, 40.0, 0,
                    -85.0, 35.0, 0
                  ]
                },
                "height" : 200000.0,
                "extrudedHeight" : 100000.0,
                "width" : 200000.0,
                "cornerType": "BEVELED",
                "material" : {
                  "solidColor" : {
                    "color" : {
                      "rgba" : [0, 0, 255, 255]
                    }
                  }
                },
                "outline" : true,
                "outlineColor" : {
                  "rgba" : [255, 255, 255, 255]
                }
              }
            }];
            let dataSourcePromise = Cesium.CzmlDataSource.load(czml);
            viewer.dataSources.add(dataSourcePromise);
            viewer.zoomTo(dataSourcePromise);
          },
            addCylinders(){
              let viewer = this.viewer;
              viewer.dataSources.removeAll();
              var czml = [{
                "id" : "document",
                "name" : "CZML Geometries: Cones and Cylinders",
                "version" : "1.0"
              }, {
                "id" : "shape1",
                "name" : "Green cylinder with black outline",
                "position" : {
                  "cartographicDegrees" : [-100.0, 40.0, 200000.0]
                },
                "cylinder" : {
                  "length" : 400000.0,
                  "topRadius" : 200000.0,
                  "bottomRadius" : 200000.0,
                  "material" : {
                    "solidColor" : {
                      "color" : {
                        "rgba" : [0, 255, 0, 128]
                      }
                    }
                  },
                  "outline" : true,
                  "outlineColor" : {
                    "rgba" : [0, 0, 0, 255]
                  }
                }
              }, {
                "id" : "shape2",
                "name" : "Red cone",
                "position" : {
                  "cartographicDegrees" : [-105.0, 40.0, 200000.0]
                },
                "cylinder" : {
                  "length" : 400000.0,
                  "topRadius" : 0.0,
                  "bottomRadius" : 200000.0,
                  "material" : {
                    "solidColor" : {
                      "color" : {
                        "rgba" : [255, 0, 0, 255]
                      }
                    }
                  }
                }
              }];
              var dataSourcePromise = Cesium.CzmlDataSource.load(czml);
              viewer.dataSources.add(dataSourcePromise);
              viewer.zoomTo(dataSourcePromise);

            },
            addSphere(){
              let viewer = this.viewer;
              viewer.dataSources.removeAll();
              var czml = [{
                "id" : "document",
                "name" : "CZML Geometries: Spheres and Ellipsoids",
                "version" : "1.0"
              }, {
                "id" : "blueEllipsoid",
                "name" : "blue ellipsoid",
                "position" : {
                  "cartographicDegrees" : [-114.0, 40.0, 300000.0]
                },
                "ellipsoid" : {
                  "radii" : {
                    "cartesian" : [200000.0, 200000.0, 300000.0]
                  },
                  "fill" : true,
                  "material" : {
                    "solidColor" : {
                      "color" : {
                        "rgba" : [0, 0, 255, 255]
                      }
                    }
                  }
                }
              }, {
                "id" : "redSphere",
                "name" : "Red sphere with black outline",
                "position" : {
                  "cartographicDegrees" : [-107.0, 40.0, 300000.0]
                },
                "ellipsoid" : {
                  "radii" : {
                    "cartesian" : [300000.0, 300000.0, 300000.0]
                  },
                  "fill" : true,
                  "material" : {
                    "solidColor" : {
                      "color" : {
                        "rgba" : [255, 0, 0, 100]
                      }
                    }
                  },
                  "outline" : true,
                  "outlineColor" : {
                    "rgbaf" : [0, 0, 0, 1]
                  }
                }
              }, {
                "id" : "yellowEllipsoid",
                "name" : "ellipsoid with yellow outline",
                "position" : {
                  "cartographicDegrees" : [-100.0, 40.0, 300000.0]
                },
                "ellipsoid" : {
                  "radii" : {
                    "cartesian" : [200000.0, 200000.0, 300000.0]
                  },
                  "fill" : false,
                  "outline" : true,
                  "outlineColor" : {
                    "rgba" : [255, 255, 0, 255]
                  },
                  "slicePartitions" : 24,
                  "stackPartitions" : 36
                }
              }];

              var dataSourcePromise = Cesium.CzmlDataSource.load(czml);
              viewer.dataSources.add(dataSourcePromise);
              viewer.zoomTo(dataSourcePromise);


            },
            cancel(){
              let viewer = this.viewer;
              viewer.dataSources.removeAll();
            }


        }
    }
</script>
<style scoped>
  .addRectangle {
    position: absolute;
    margin-left: 20px;
    margin-top:7px;
    z-index: 999;
  }
  .addCorridor {
    position: absolute;
    margin-left: 110px;
    margin-top:7px;
    z-index: 999;
  }
  .addCylinders{
    position: absolute;
    margin-left: 185px;
    margin-top:7px;
    z-index: 999;
  }
  .addSphere{
    position: absolute;
    margin-left: 295px;
    margin-top:7px;
    z-index: 999;
  }
  .cancel{
    position: absolute;
    margin-left: 395px;
    margin-top:7px;
    z-index: 999;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
